export class TransactionNoteDto{
    public id: number;
    public resourceId: string;
    public notes: string;
    public clientDetailsId: number;
    public organizationDetailsId: number;
}